module.exports = __webpack_public_path__ + "img/like1.a6e793ff.png";